export default "__VITE_ASSET__BwG_sSWw__"